import { Avatar } from "@/components/Avatar";
import { plural } from "@/lib/plural";
import type { TeamMember } from "./shared";

const AVATARS_SHOWN = 3;

export function MemberStack({ members }: { members: TeamMember[] }) {
  if (members.length === 0) {
    return <span className="text-sm text-foreground/70">No members</span>;
  }

  const shown = members.slice(0, AVATARS_SHOWN);
  const hidden = members.length - shown.length;

  return (
    <span
      className="flex items-center"
      aria-label={plural(members.length, "member")}
    >
      {shown.map((member) => (
        <span
          key={member.userId}
          title={member.name}
          className="-ml-2 inline-flex rounded-full ring-2 ring-background first:ml-0 group-hover:ring-surface"
        >
          <Avatar
            name={member.name}
            email={member.email}
            avatarId={member.avatarId}
            size="md"
          />
        </span>
      ))}
      {hidden > 0 && (
        <span className="ml-2 text-sm tabular-nums text-foreground/70">
          +{hidden}
        </span>
      )}
    </span>
  );
}
